import React from "react";
import { Input, Select, DatePicker, Row, Col } from "antd";
import { SectionCard } from "../../../../../components/shared";
import dayjs from "dayjs";
import { LabOrder } from "../../../../../types/lab/LabOrderTypes";
import { LabOrderShippingStatusOptions, DeliveryVendorOptions } from "../../../../../types/lab/LabOrderTypes";

const { TextArea } = Input;

interface OrderShippingProps {
	orderData: Partial<LabOrder>;
	updateOrderData: (field: string, value: any) => void;
}

const OrderShipping: React.FC<OrderShippingProps> = ({ orderData, updateOrderData }) => {
	const isDisabled = orderData.status === "completed";

	return (
		<SectionCard title="Shipping & Tracking" style={{ marginBottom: 16 }}>
			<Row gutter={[12, 12]}>
				<Col xs={24} sm={12} md={8}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Shipping Status</label>
					<Select
						value={orderData.shipping_status || null}
						options={LabOrderShippingStatusOptions}
						onChange={(value) => updateOrderData("shipping_status", value)}
						disabled={isDisabled}
						placeholder="Select Shipping Status"
						size="small"
						style={{ width: "100%" }}
					/>
				</Col>

				<Col xs={24} sm={12} md={8}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Tracking Number</label>
					<Input value={orderData.tracking_number || ""} onChange={(e) => updateOrderData("tracking_number", e.target.value)} disabled={isDisabled} placeholder="Enter tracking number" size="small" />
				</Col>

				<Col xs={24} sm={12} md={8}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Delivery Vendor</label>
					<Select
						value={orderData.delivery_vendor || null}
						options={DeliveryVendorOptions}
						onChange={(value) => updateOrderData("delivery_vendor", value)}
						disabled={isDisabled}
						placeholder="Select Delivery Vendor"
						size="small"
						style={{ width: "100%" }}
					/>
				</Col>

				<Col xs={24} sm={12} md={8}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Shipped At</label>
					<DatePicker
						value={orderData.shipped_at ? dayjs(orderData.shipped_at) : null}
						onChange={(date) => updateOrderData("shipped_at", date?.toISOString())}
						showTime={{ format: "HH:mm" }}
						format="DD/MM/YYYY HH:mm"
						disabled={isDisabled}
						placeholder="Select shipped date and time"
						size="small"
						style={{ width: "100%" }}
					/>
				</Col>

				<Col xs={24} sm={12} md={8}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Delivered At</label>
					<DatePicker
						value={orderData.delivered_at ? dayjs(orderData.delivered_at) : null}
						onChange={(date) => updateOrderData("delivered_at", date?.toISOString())}
						showTime={{ format: "HH:mm" }}
						format="DD/MM/YYYY HH:mm"
						disabled={isDisabled}
						placeholder="Select delivered date and time"
						size="small"
						style={{ width: "100%" }}
					/>
				</Col>

				<Col xs={24} sm={12} md={16}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Shipping Address</label>
					<TextArea value={orderData.shipping_address || ""} onChange={(e) => updateOrderData("shipping_address", e.target.value)} disabled={isDisabled} placeholder="Enter shipping address" rows={2} size="small" />
				</Col>

				<Col xs={24}>
					<label style={{ display: "block", fontSize: "12px", marginBottom: 4, fontWeight: 500 }}>Shipping Notes</label>
					<TextArea value={orderData.shipping_notes || ""} onChange={(e) => updateOrderData("shipping_notes", e.target.value)} disabled={isDisabled} placeholder="Enter shipping notes" rows={2} size="small" />
				</Col>
			</Row>
		</SectionCard>
	);
};

export default OrderShipping;
